import { render, staticRenderFns } from "./MeasurementViewer.vue?vue&type=template&id=84973f0e&scoped=true&"
import script from "./MeasurementViewer.vue?vue&type=script&lang=js&"
export * from "./MeasurementViewer.vue?vue&type=script&lang=js&"
import style0 from "./MeasurementViewer.vue?vue&type=style&index=0&id=84973f0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84973f0e",
  null
  
)

export default component.exports